import {
  DigitalDocumentStudentConfirmationSchoolTypeEnum
} from '@/models/digital-document-student-confirmation-form-model';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function digitalDocumentStudentConfirmationSchoolTypeNameFilter(type: DigitalDocumentStudentConfirmationSchoolTypeEnum): string {
  switch (type) {
    case DigitalDocumentStudentConfirmationSchoolTypeEnum.University: return i18n.t(LF.IStudyAtUniversity) as string;
    case DigitalDocumentStudentConfirmationSchoolTypeEnum.School: return i18n.t(LF.IStudyAtSchool) as string
  }
}
